import React from 'react'
import { Row, Col, Card } from 'antd'
import PropTypes from 'prop-types'

export default function WidgetLayout(props) {
  const { children } = props
  return (
    <Row>
      <Col style={{ textAlign: 'center', overflow: 'hidden', margin: 'auto' }}>
        <Card
          size="small"
          // title="Card Title" Title Here for Future Use
          style={{
            margin: 'auto',
            border: '1px solid #1890ff',
            padding: '0px',
            overflow: 'hidden',
          }}
          bodyStyle={{
            padding: '0px',
          }}
        >
          {children}
          <span>
            Calculator by
            <b>
              <a href="https://fintrakk.com" target="_parent" rel="nofollow">
                {` Fintrakk.com`}
              </a>
            </b>
          </span>
        </Card>
      </Col>
    </Row>
  )
}

WidgetLayout.propTypes = { children: PropTypes.element.isRequired }
